import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { SpaceBetween, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setLoading } from '../../../../commons/functions';



export const ReportsFinancesDuplicatesPage = () => {
    const { menu } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();



    const [duplicates, setDuplicates] = useState<any[]>([]);

    const handleGetDuplicates = async () => {

        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/duplicates',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({})
            });
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.movements) {
                setDuplicates(data.movements);
            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleGetDuplicates();
    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Abonos duplicados</Header>
                    <Table
                        variant='embedded'
                        columnDefinitions={[
                            {
                                id: 'displayName',
                                header: 'Usuario',
                                cell: item => item.displayName,
                            },
                            {
                                id: 'ammount',
                                header: 'Monto',
                                cell: item => formatCurrency(item.ammount, "CLP"),
                            },
                            {
                                id: 'dateTransaction',
                                header: 'Fecha',
                                cell: item => item.dateTransaction,
                            },
                            {
                                id: 'idMovement',
                                header: 'ID Movimiento',
                                cell: item => item.idMovement,
                            },

                        ]}
                        items={duplicates}
                        loadingText="Cargando abonos duplicados..."
                    />

                </SpaceBetween>
            }
        />
    );
};
